import { ROUTE_NAME } from 'enums/routes'
import { VIDEO_BANNER_TYPE } from 'enums/video-banner'

export const BANNER_POSITION = 7
export const VIDEO_BANNER_POSITION = 2

export const VIDEO_BANNER_TYPE_BY_ROUTE_NAME = {
  [ROUTE_NAME.ALL_NEWS]: VIDEO_BANNER_TYPE.ALL_NEWS,
  [ROUTE_NAME.CATEGORY]: VIDEO_BANNER_TYPE.CATEGORY,
  [ROUTE_NAME.CATEGORY_SUBCATEGORY]: VIDEO_BANNER_TYPE.SUBCATEGORY
}

export const ARTICLE_SLOT_CLASS_NAME = 'infinite-news__article-slot'
